import { isPathAllowedDuringOnboarding, ONBOARDING_PATH } from './constants'

export type OnboardingGateState = {
  gateResolved: boolean
  isRequired: boolean
  isRequirementActive: boolean
}

export type OnboardingRouteGateAction =
  | { type: 'noop' }
  | { type: 'replace'; href: string }
  | { type: 'endExit' }

const isOnboardingPath = (pathname: string): boolean =>
  pathname === ONBOARDING_PATH || pathname.startsWith(`${ONBOARDING_PATH}/`)

export const resolveOnboardingRouteGateAction = ({
  gate,
  pathname,
  exitHref,
}: {
  gate: OnboardingGateState
  pathname: string
  exitHref: string | null
}): OnboardingRouteGateAction => {
  if (!gate.gateResolved) {
    return { type: 'noop' }
  }

  if (exitHref) {
    if (isOnboardingPath(pathname)) {
      if (!gate.isRequired) {
        return { type: 'replace', href: exitHref }
      }
      return { type: 'noop' }
    }

    if (gate.isRequirementActive) {
      return { type: 'noop' }
    }

    return { type: 'endExit' }
  }

  if (!gate.isRequired && isOnboardingPath(pathname)) {
    return { type: 'replace', href: '/' }
  }

  if (!gate.isRequired) {
    return { type: 'noop' }
  }

  if (isPathAllowedDuringOnboarding(pathname)) {
    return { type: 'noop' }
  }

  return { type: 'replace', href: ONBOARDING_PATH }
}

export const shouldShowOnboardingFallback = ({
  gate,
  pathname,
  exitHref,
}: {
  gate: OnboardingGateState
  pathname: string
  exitHref?: string | null
}): boolean => {
  if (isPathAllowedDuringOnboarding(pathname)) {
    return false
  }

  if (!gate.gateResolved) {
    return true
  }

  if (exitHref && gate.isRequirementActive) {
    return false
  }

  return gate.isRequired
}
